import React from 'react';
import { Filters } from '../../../../contexts/SpecialistContext';
import * as S from './styles';

const xIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/xIcon.svg';

type FilterDisplayProps = {
  filtersCounter: Filters;
  onFilterPress: () => void;
  onResetFilter: () => void;
};

export const FilterDisplay: React.FC<FilterDisplayProps> = ({ filtersCounter, onFilterPress, onResetFilter }) => {
  const handleCounter = () => {
    let counter = 0;
    if (filtersCounter.units.length) counter += 1;
    if (filtersCounter.expertise.length) counter += 1;
    if (filtersCounter.medicalField.length) counter += 1;

    return counter;
  };

  const formattedCounter = handleCounter() <= 9 ? `0${handleCounter()}` : handleCounter();

  return (
    <S.Container>
      {handleCounter() > 0 ? (
        <>
          <S.BlueContainer onClick={onFilterPress}>
            <S.FilterText>Filtrar busca</S.FilterText>
            <S.RoundedDiv>
              <S.CounterText>{formattedCounter}</S.CounterText>
            </S.RoundedDiv>
          </S.BlueContainer>
          <S.CloseDiv onClick={onResetFilter}>
            <img src={xIcon} alt="resetFilter" />
          </S.CloseDiv>
        </>
      ) : (
        <S.FilterText onClick={onFilterPress}>Filtrar</S.FilterText>
      )}
    </S.Container>
  );
};
